module.exports = __webpack_public_path__ + "img/logo-upstart.1c3981d7.png";